import script from "./UseQuotationTemplateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UseQuotationTemplateModal.vue?vue&type=script&setup=true&lang=ts"

import "./UseQuotationTemplateModal.vue?vue&type=style&index=0&id=7678253a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7678253a"]])

export default __exports__